import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Typography,
  IconButton
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { find, sortBy, map, orderBy } from "lodash";
import { getAllAssignedBooks, getUserLog } from "./Services";
import { getAsset, getClassNames, joinByKeys } from "../../Js/Common";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const sortingOptionsList = ["Name", "Attempted Books"];

const ReaderBoard = (props) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const navigation = useNavigate();

  let [allClasses, setAllClasses] = useState([]);
  let [books, setBooks] = useState([]);
  let [learners, setLearners] = useState([]);
  let [trainers, setTrainers] = useState([]);
  let [sortingOptions, setSortingOptions] = useState(sortingOptionsList);
  let [selectedTrainers, setSelectedTrainers] = useState([]);
  let [selectedClass, setselectedClass] = useState("");
  let [selectedSort, setselectedSort] = useState("Name");
  let [assessmentYearItems, setAssessmentYearItems] = useState([
    { 'label': '2025-2026', 'value': '2025-04-01_2026-03-31' },
    { 'label': '2024-2025', 'value': '2024-04-01_2025-03-31' },
    { 'label': '2023-2024', 'value': '2023-04-01_2024-03-31' },
  ]);
  let [selectedAssessmentYear, setSelectedAssessmentYear] = useState(null);
  let [assessmentYear, setAssessmentYear] = useState(assessmentYearItems[0].label);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  // const serverRole = useSelector((state) => state.defs.serverRole);
  const { siteConfig, serverRole } = useSelector((state) => state.defs);

  useEffect(() => {
    let innerFun = async () => {
      let createdBy = [userInfo.uid];

      dispatch(commonSliceActions.setLoader(true));

      if (userInfo.rolesInfo.title.toLowerCase() != "trainer") {
        let userdata = await fetchRoleWiseUser("Trainer");
        setTrainers(userdata.data);
        createdBy = map(userdata.data, "uid");
        setSelectedTrainers(createdBy);
      }

      getAssignedBooks(createdBy);
    };
    innerFun();
  }, []);

  useEffect(() => {    
    if (selectedAssessmentYear) {
      dispatch(commonSliceActions.setLoader(true));
      fetchLearners(selectedClass, books);
    }
  }, [selectedAssessmentYear])

  let getAssignedBooks = async (createdBy) => {
    let AllBooks = await getAllAssignedBooks({
      tasktype: "library",
      site_uuid: userInfo.site_uuid,
      created_by: createdBy,
      $limit: -1,
    });

    let uniqBooks = [];

    AllBooks.data.forEach((val, index) => {
      if (uniqBooks.indexOf(val.data1.exersices[0]) == -1) {
        uniqBooks.push(val.data1.exersices[0]);
      }
    });

    let assetData = await getAsset({
      $in: uniqBooks,
    });
    let sortedBooks = sortBy(assetData.data, [
      (o) => {
        return o.asset_name;
      },
    ]);

    setBooks(sortedBooks);
    let classData = await getClassNames(userInfo.site_uuid);
    console.log("allClasses", classData);
    setAllClasses(classData);
    if (classData.length > 0) {
      setselectedClass(classData[0].id);
      fetchLearners(classData[0].id, sortedBooks);
    }
  };

  const fetchRoleWiseUser = async (type, id = null) => {
    let params = {
      query: {
        $select: ["uid", "title"],
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    let learnerRole = find(resRolesData.data, { title: type });

    let params1 = {
      query: {
        $select: ["uid", "name"],
        $limit: -1,
        role_uid: learnerRole.uid,
        site_uuid: userInfo.site_uuid,
        status: true,
      },
    };

    if (id) {
      params1.query.belongs_to = id;
    }
    let resUsersData = await getUsersByRoleId(params1);
    return resUsersData;
  };

  const fetchLearners = async (id, books) => {
    let userdata = await fetchRoleWiseUser("learner", id);
    let soredLearners = sortBy(userdata.data, [
      (o) => {
        return o.name.firstname;
      },
    ]);

    getAttemptedBooks(books, soredLearners);
  };

  const getAttemptedBooks = async (allBooks, allLeraners) => {
    console.log("allBooks", allBooks);
    console.log("allLeraners", allLeraners);
    let updatedAt = '';
    let assessmentYearVal = [];
    if (selectedAssessmentYear) {
      assessmentYearVal = selectedAssessmentYear.split("_");
    } else {
      assessmentYearVal = assessmentYearItems[0]['value'].split("_");
    }
    console.log("getAttemptedBooks=====>", assessmentYearVal);
    updatedAt = { $and: { $gt: assessmentYearVal[0], $lt: assessmentYearVal[1] } }

    let booksIds = map(allBooks, "asset_uid");
    let userIds = map(allLeraners, "uid");
    let logs = await getUserLog({
      $limit: -1,
      site_uuid: userInfo.site_uuid,
      actor: userIds,
      context: {
        assetId: {
          $in: booksIds,
        },
      },
      verb: "attemptAssignment",
      updated_at: updatedAt,
    });

    let newArr = allLeraners.map((val) => {
      let count = 0;
      let booksArr = allBooks.map((book) => {
        let foundObj = find(logs.data, (o) => {
          return o.actor == val.uid && o.context.assetId == book.asset_uid;
        });
        if (foundObj) {
          count++;
        }
        return {
          bookname: book.asset_name,
          bookid: book.asset_uid,
          attempted: foundObj ? true : false,
        };
      });
      return {
        ...val,
        attemptedBooks: count,
        books: booksArr,
      };
    });

    if (selectedSort == "Attempted Books") {
      newArr = orderBy(newArr, ["attemptedBooks"], ["desc"]);
    }
    setLearners(newArr);
    dispatch(commonSliceActions.setLoader(false));
  };

  const handleChange = (arg) => {
    dispatch(commonSliceActions.setLoader(true));
    setselectedClass(arg.target.value);
    fetchLearners(arg.target.value, books);
  };

  const handleTrainerChange = (arg) => {
    dispatch(commonSliceActions.setLoader(true));
    let temparr = [...selectedTrainers];
    let pos = selectedTrainers.indexOf(arg);
    if (pos == -1) {
      temparr.push(arg);
    } else {
      temparr.splice(pos, 1);
    }
    setSelectedTrainers(temparr);
    getAssignedBooks(temparr);
  };

  const handleSortChange = (arg) => {
    setselectedSort(arg.target.value);
    let soredData = [];
    if (arg.target.value == "Name") {
      soredData = sortBy(learners, [
        (o) => {
          return o.name.firstname;
        },
      ]);
    } else {
      soredData = orderBy(learners, ["attemptedBooks"], ["desc"]);
    }
    setLearners(soredData);
  };

  const handleAssessmentYearChange = (itemData) => {    
    setAssessmentYear(itemData.label);
    setSelectedAssessmentYear(itemData.value);
  };

  const standardName = (id) => {
    let foundObj = find(allClasses, { id: id });
    let className = 'NA';
    if (foundObj) {
      className = foundObj.value;
    }
    return className;
  };

  const downloadReaderBoardCsv = () => {
    // console.log("learners====>", learners);
    let className = standardName(selectedClass);

    if (learners.length > 0) {
      let csv = '';
      csv = 'School Name,Class,Academic Year\n';
      csv = csv + siteConfig.customer.customerName + ',' + className + ',' + assessmentYear + '\n\n';

      csv = csv + 'Student Name,Attempted Books,Book Name\n';
      learners.forEach((elementData, index) => {
        let learnerName = joinByKeys(elementData.name, ['firstname', 'lastname'], ' ')
        let attemptedBooks = elementData.attemptedBooks;
        csv = csv + learnerName + "," + attemptedBooks + '\n';
        elementData.books.forEach((bookObj) => {
          if (bookObj.attempted) {
            csv += ",," + bookObj.bookname.replace(",", "") + '\n';
          }
        })
      });
      let hiddenElement = document.createElement('a');
      hiddenElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
      hiddenElement.setAttribute('download', `ReaderBoard_${assessmentYear}_${className}.csv`);
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
      document.body.removeChild(hiddenElement);
    } else {
      alert('Learner data not available!');
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} style={{ height: "86vh", overflow: "hidden" }}>
        <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <Grid item>
            <Typography sx={{fontSize: '1.1rem', fontWeight: '600', color: '#DB8829', pl:2}}>
              Reader Board
            </Typography>
          </Grid>
          <Grid item>
            <Grid container sx={{ flexDirection: 'row' }}>
              <Grid item>
                {(serverRole == 'WEB_HOST' && userInfo.rolesInfo.title.toLowerCase() == 'admin') &&
                  <WorkspacePremiumIcon sx={{ fontSize: "2vw", color: '#DB8829', p: 1.2 }} onClick={() => {
                    dispatch(commonSliceActions.setParamsData({
                      "allClasses": allClasses,
                    }));
                    navigation(`/Library/ReaderBoardCertificate`);
                  }} />
                }
              </Grid>
              <Grid item>
                {(userInfo.rolesInfo.title.toLowerCase() == 'admin' || userInfo.rolesInfo.title.toLowerCase() == 'incharge') &&
                  <IconButton color="primary" onClick={() => { downloadReaderBoardCsv() }}>
                    <CloudDownloadIcon sx={{ fontSize: "2.4vw" }} />
                  </IconButton>
                }
              </Grid>
              <Grid item>
                <FormControl sx={{ m: 1, minWidth: 140 }} size="small">
                  <InputLabel sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}>Academic Year</InputLabel>
                  <Select
                    autoWidth
                    label="Academic Year"
                    value={assessmentYear}
                    sx={{
                      borderRadius: 10,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    {assessmentYearItems &&
                      assessmentYearItems.map((itemData, ind) => {
                        return (
                          <MenuItem
                            key={`${ind}_year`}
                            value={itemData.label}
                            sx={{
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                            onClick={() => { handleAssessmentYearChange(itemData) }}
                          >
                            {itemData.label}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel
                    sx={{
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  >
                    Sort
                  </InputLabel>
                  <Select
                    autoWidth
                    value={selectedSort}
                    label="Sort"
                    onChange={handleSortChange}
                    sx={{
                      borderRadius: 10,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    {sortingOptions &&
                      sortingOptions.map((obj, ind) => {
                        return (
                          <MenuItem
                            key={`${ind}_sort`}
                            value={obj}
                            sx={{
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {obj}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                {userInfo &&
                  userInfo.rolesInfo.title.toLowerCase() != "trainer" && (
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                      <InputLabel
                        sx={{
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                      >
                        Trainers
                      </InputLabel>
                      <Select
                        autoWidth
                        value={selectedTrainers}
                        label="Trainers"
                        multiple
                        SelectDisplayProps={{ style: { width: 100 } }}
                        sx={{
                          borderRadius: 10,
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                        renderValue={(selected) => {
                          return selected
                            .map((x) => {
                              return find(trainers, { uid: x }).name.firstname;
                            })
                            .join(",");
                        }}
                      >
                        {trainers &&
                          trainers.map((obj, ind) => {
                            return (
                              <MenuItem
                                key={`${ind}_class`}
                                value={obj.uid}
                                sx={{
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                                onClick={() => {
                                  handleTrainerChange(obj.uid);
                                }}
                              >
                                <Checkbox
                                  checked={selectedTrainers.indexOf(obj.uid) > -1}
                                />
                                <ListItemText
                                  primary={`${obj.name.firstname} ${obj.name.lastname}`}
                                />
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  )}
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel
                    sx={{
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  >
                    Class
                  </InputLabel>
                  <Select
                    autoWidth
                    value={selectedClass}
                    label="Class"
                    onChange={handleChange}
                    sx={{
                      borderRadius: 10,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    {allClasses &&
                      allClasses.map((obj, ind) => {
                        return (
                          <MenuItem
                            key={`${ind}_class`}
                            value={obj.id}
                            sx={{
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {obj.value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <TableContainer component={Paper}  className={styles.scrollBar}   style={{ height: "90%", border: '1px solid #DB8829', borderRadius: 5}}>
          <Table sx={{}} aria-label="simple table" stickyHeader={true}>
            <TableHead>
              <TableRow style={{backgroundColor: '#DB8829'}}>
                <TableCell
                  style={{ backgroundColor: "#DB8829", color: "#FFF" }}
                  sx={{ paddingY: 0 }}
                  className={styles.sticky1}
                >
                  {" "}
                  Books{" "}
                </TableCell>
                {books &&
                  books.map((book, bindex) => {
                    return (
                      <TableCell
                        align="center"
                        key={`${bindex}_book`}
                        style={{ backgroundColor: "#DB8829", color: "#FFF", lineHeight: 1.2 }}
                        sx={{ paddingY: 0}}
                      >
                        <span>{book.asset_name}</span>
                      </TableCell>
                    );
                  })}
              </TableRow>
            </TableHead>
            <TableBody>
              {learners &&
                learners.map((val, index) => {
                  return (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={`${index}_Row`}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ paddingY: 1 }}
                        className={styles.sticky}
                      >
                        {`${val.name.firstname} ${val.name.lastname} (${val.attemptedBooks})`}
                      </TableCell>
                      {val.books &&
                        val.books.map((bookObj, indexObj) => {
                          return (
                            // <Tooltip
                            //   title={bookObj.bookname}
                            //   arrow
                            //   slotProps={{
                            //     popper: {
                            //       modifiers: [
                            //         {
                            //           name: "offset",
                            //           options: {
                            //             offset: [0, -14],
                            //           },
                            //         },
                            //       ],
                            //     },
                            //   }}
                            // >
                            <TableCell
                              align="center"
                              key={`${index}_${indexObj}_learnerBook`}
                              sx={{ paddingY: 1 }}
                            >
                              {bookObj.attempted && (
                                // <CircleIcon
                                //   color="black"
                                //   align="center"
                                //   fontSize="5"
                                // />
                                <Fade in={true} timeout={750}>
                                  <img src={require('../../assets/starBadgh.png')} width={35}></img>
                                </Fade>
                              )}{" "}
                            </TableCell>
                            // </Tooltip>
                          );
                        })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.4em",
      height: "0.4em"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  sticky: {
    position: "sticky",
    left: 0,
    background: "white",
    borderRight: "1px solid #CCC !important"
  },
  sticky1: {
    position: "sticky",
    left: 0,
    background: "white",
    zIndex: 100
  }
});
export default ReaderBoard;
